import { values } from 'lodash';

export const getConstantValue = <T>(
  constants: Record<string, T>,
  value?: string
): T | null => {
  const foundType = values(constants).find(
    item => String(item).toLowerCase() === (value || '').toLowerCase()
  );
  return foundType || null;
};

export default { getConstantValue };
